import { createFileRoute } from '@tanstack/react-router';
import { loadShire, makeShireSubPageHead, type ShireLoaderData } from '../components/shared/shire-sub-route';
import { ShireSubPageShell } from '../components/shared/ShireSubPageShell';
import { CommunityFacilitiesSection } from '../components/shared/CommunityFacilitiesSection';
import { PublicInternetAccessSection } from '../components/shared/PublicInternetAccessSection';
import { ShireEventsSection } from '../components/shared/ShireEventsSection';

export const Route = createFileRoute('/shire/$name_/community')({
  loader: ({ params }) => loadShire(params.name),
  head: (ctx) =>
    makeShireSubPageHead(
      (ctx as { loaderData?: ShireLoaderData } | undefined)?.loaderData,
      'Community',
      'Community facilities, free public internet and major annual events for this shire.',
    ),
  component: CommunityPage,
});

function CommunityPage() {
  const { shire } = Route.useLoaderData() as ShireLoaderData;
  return (
    <ShireSubPageShell
      shire={shire}
      eyebrow="Community"
      title="Community life"
      lede={`Halls and community facilities, free public internet and major annual events across the Shire of ${shire.name}.`}
    >
      <CommunityFacilitiesSection shireId={shire.id} />
      <PublicInternetAccessSection shireId={shire.id} />
      <ShireEventsSection shireId={shire.id} />
    </ShireSubPageShell>
  );
}
